import actionTypes from 'redux/actionTypes';

/**
 * Toggles the resident party value
 */
export const toggleResidentParty = () => (dispatch) =>
    dispatch({
        type: actionTypes.RESIDENT_TOGGLE_DISPLAY_PARTY,
    });
